<template>
  <div>
    <!-- <v-card
      class="mx-4 mt-4"
      v-if="isStaff"
      shaped
      elevation="12"
      outlined
      max-width="344"
    >
      <v-list-item three-line>
        <v-autocomplete
          class="mr-4"
          prepend-inner-icon="search"
          v-model="selectedClientReference"
          :items="clients"
          solo-inverted
          flat
          hide-details
          :label="'Search Client'"
          @change="getClientProfile()"
        ></v-autocomplete>
        <v-btn
          :style="{
            'background-color': getThemeColor,
            color: getSecondaryColor,
          }"
          dark
          @click="openAddClientDialog()"
        >
          <v-icon>mdi-account-plus</v-icon>
        </v-btn>
      </v-list-item>
    </v-card> -->
    <!-- <CardAlert class="mt-4 mx-4" :color="getThemeColor"> -->
    <v-toolbar dark :color="getThemeColor">
      <!-- <v-toolbar-subtitle>{{ getCompanyLabels.client }}s</v-toolbar-subtitle> -->
      <v-autocomplete
        clearable
        v-model="selectedClientReference"
        :items="clients"
        class="ml-4"
        flat
        hide-no-data
        hide-details
        :label="'Select ' + getCompanyLabels.client"
        solo-inverted
        @change="getClientProfile()"
      ></v-autocomplete>
      <v-btn
        fab
        color="grey darken-1"
        small
        :class="isMobile ? 'mb-6 ml-2' : 'ml-2'"
        dark
        @click="openAddClientDialog()"
      >
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- </CardAlert> -->
    <GlobalDialogSlot
      :title="'Add ' + getCompanyLabels.client"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateClient @client-created="getNewClient"></CreateClient>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import CreateClient from "@/components/Clients/CreateClient.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
//import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  name: "Client",
  components: {
    CreateClient,
    GlobalDialogSlot,
    //CardAlert
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },

    computedclientProfile() {
      return this.clientProfile;
    },
    getCustomerName() {
      return this.$store.getters.getCustomerName;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-all-clients", this.getAccessToken)
      .then((clients) => {
        this.clientsData = clients;
        clients.forEach((client) => {
          this.clients.push({
            text:
              client.name +
              " " +
              " | " +
              client.id_number +
              " | " +
              client.institution,
            value: client.id_number,
          });
        });
        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    clients: [],
    clientsData: [],
    selectedClientReference: null,
    createClientDialog: false,
    addClientDialog: false,
    dialog: false,
  }),
  methods: {
    getClientProfile() {
      const clientArr = this.clientsData.filter((client) => {
        return client.id_number == this.selectedClientReference;
      });
      this.$emit("client-selected", clientArr[0]);
    },
    getNewClient(client) {
      this.clients.push({
        text:
          client.name +
          " " +
          " | " +
          client.id_number +
          " | " +
          client.institution,
        value: client.id_number,
      });

      this.$emit("new-client-created", client);
      this.dialog = false;
    },
    openAddClientDialog() {
      this.dialog = true;
    },
    createClient() {
      this.createClientDialog = true;
    },
  },
};
</script>

<style></style>
